// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface V1ResourcePolicyOverride
 */
export interface V1ResourcePolicyOverride {
  /**
   *
   * @type {string}
   * @memberof V1ResourcePolicyOverride
   */
  overrideName?: string;
  /**
   *
   * @type {string}
   * @memberof V1ResourcePolicyOverride
   */
  targetSize?: string;
}

/**
 * Check if a given object implements the V1ResourcePolicyOverride interface.
 */
export function instanceOfV1ResourcePolicyOverride(
  value: object,
): value is V1ResourcePolicyOverride {
  return true;
}

export function V1ResourcePolicyOverrideFromJSON(
  json: any,
): V1ResourcePolicyOverride {
  return V1ResourcePolicyOverrideFromJSONTyped(json, false);
}

export function V1ResourcePolicyOverrideFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1ResourcePolicyOverride {
  if (json == null) {
    return json;
  }
  return {
    overrideName:
      json['overrideName'] == null ? undefined : json['overrideName'],
    targetSize: json['targetSize'] == null ? undefined : json['targetSize'],
  };
}

export function V1ResourcePolicyOverrideToJSON(
  json: any,
): V1ResourcePolicyOverride {
  return V1ResourcePolicyOverrideToJSONTyped(json, false);
}

export function V1ResourcePolicyOverrideToJSONTyped(
  value?: V1ResourcePolicyOverride | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    overrideName: value['overrideName'],
    targetSize: value['targetSize'],
  };
}
